import {
  APP_SITE_ORIGIN,
  MARKETING_SITE_ORIGIN,
  affiliateTrackingUrl,
  toAppUrl,
  toMarketingUrl,
} from "./siteDomains";

export const MARKETING_HOME_URL = `${MARKETING_SITE_ORIGIN}/`;
export const APP_HOME_URL = `${APP_SITE_ORIGIN}/`;

/** Rota interna do painel após login (sempre no app). */
export const POST_LOGIN_ROUTE = "/painel";

export { APP_SITE_ORIGIN, MARKETING_SITE_ORIGIN, affiliateTrackingUrl, toAppUrl, toMarketingUrl };
